import { render, staticRenderFns } from "./GanttObjectives.vue?vue&type=template&id=2640f8ee&scoped=true&"
import script from "./GanttObjectives.vue?vue&type=script&lang=js&"
export * from "./GanttObjectives.vue?vue&type=script&lang=js&"
import style0 from "./GanttObjectives.vue?vue&type=style&index=0&id=2640f8ee&prod&lang=scss&scoped=true&%3Asrc=cssImportPath&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2640f8ee",
  null
  
)

export default component.exports